import { CvInternshipInputDto } from '@/shared/cv/cv.dto';
import { EsCvInternship } from '@/shared/cv/cv.es.dto';
import { toFormat } from '@/lib/utils/formatters';

export function buildInternshipFormDefaultValues(
  langId: number,
  internship?: EsCvInternship
): CvInternshipInputDto {
  if (!internship) {
    return {
      langId,
      tcenter: '',
      title: '',
      descr: '',
      startDate: '',
      endDate: null,
      companyId: 0,
    };
  }

  return {
    id: internship.id,
    langId,
    tcenter: internship.tcenter ?? '',
    title: internship.title ?? '',
    descr: internship.descr ?? '',
    startDate: toFormat(internship.startDate),
    endDate: internship.endDate ? toFormat(internship.endDate) : null,
    companyId: internship.com?.id ?? 0,
  };
}

export function mapInternshipFormToPayload(
  data: CvInternshipInputDto,
  langId: number,
  internshipId?: number
): CvInternshipInputDto {
  return {
    ...data,
    ...(internshipId ? { id: internshipId } : {}),
    langId,
    endDate: data.endDate ?? null,
    descr: data.descr ?? '',
    companyId: data.companyId ?? 0,
  };
}

export function getInternshipFormTitle(isUpdate: boolean, isMn: boolean): string {
  if (isUpdate) {
    return isMn ? 'Дадлага засах' : 'Edit internship';
  }
  return isMn ? 'Дадлага нэмэх' : 'Add internship';
}
